import { render, staticRenderFns } from "./u-text-field-underlined.vue?vue&type=template&id=794aacf5&scoped=true&"
import script from "./u-text-field-underlined.vue?vue&type=script&lang=js&"
export * from "./u-text-field-underlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794aacf5",
  null
  
)

export default component.exports